import { observable, makeObservable, action, runInAction } from 'mobx';
import ToastUtils from '@/utils/ToastUtils';
import {
    handleAgentList,
    checkToken,
    getUserInfo,
    handleAgentDetail,
    handleGetTenantId,
    handleGetStudentName,
    checkBusiness,
    getAgentIsValid,
    getTenantConfigReq
} from '@/api/grt/ai';
import { Storage } from '@/utils/Storage';
import { errMap, errMsgMap } from '@/utils/Page/constant';
import { getBusinessSearchParams } from '@/utils/Page';
import { getLoginAndOutGoPath } from '@/api/login';
import chat from './chat';
import { changeName } from '@/utils/global';
class grtAi {
    constructor() {
        makeObservable(this);
    }
    @observable eggShow = false;
    @action
    setEggShow = (flag) => {
        this.eggShow = flag;
    };
    @observable side = null;
    @action
    setSide = (side) => {
        this.side = side;
    };
    @observable agentId = null;
    @action
    setAgentId = (id) => {
        this.agentId = id;
    };
    @observable navigate = null;
    @action
    setNavigate = (fn) => {
        this.navigate = fn;
    };
    @observable searchParams = null;
    @action
    setSearchParams = (fn) => {
        this.searchParams = fn;
    };
    @observable isLogin = false;
    @action setIsLogin = (flag) => {
        this.isLogin = flag;
    };
    @observable studentName = null; //学员姓名
    @action
    setStudentName = (data) => {
        this.studentName = data;
    };
    @observable userInfo = {
        id: 1 //用户id
    };
    @action
    setUserInfo = (data) => {
        this.userInfo = Object.assign({}, this.userInfo, data);
    };
    @observable state = {
        agentLoading: true,
        loginLoading: false,
        //智能体--------
        agentList: [], //智能体列表
        currentAgent: { error: true } //当前的智能体
    };
    @action
    setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };

    //校验智能体是否有效
    checkAgentIsValid = async (agentId) => {
        let searchParams = getBusinessSearchParams();
        const res = await getAgentIsValid({
            agent_id: agentId,
            ...searchParams
        });

        if (res && !res.success) {
            let codeMap = {
                A3990: errMap.errlink,
                A3991: errMap.businessOff,
                A3992: errMap.agentHasOff,
                A3994: errMap.noOper
            };
            if (res?.code === '401') {
                chat.goLogin();
                return false;
            }
            return {
                error: true,
                code: codeMap[res?.code]
            };
        }
        return true;
    };
    //获取智能体详情
    getAgentDetail = async (agentId) => {
        let businessRes = await this.checkAgentIsValid(agentId);
        if (!businessRes) {
            return false;
        }
        if (businessRes?.error) {
            this.setState({ currentAgent: { ...businessRes }, agentLoading: false });
            return;
        }
        this.setState({ agentLoading: true });
        let obj = {};
        const res = await handleAgentDetail(agentId);
        if (res && res.success) {
            obj = res?.data || {};
            if (res?.data?.publish_state !== 1) {
                let errTip = `${errMsgMap[res?.data?.publish_state]}`;
                obj = { ...res?.data, error: true, code: res?.data?.publish_state };
                ToastUtils.showAbnormalToast(errTip);
            }
        } else {
            obj = { error: res?.msg || '查询智能体详情失败' };
            ToastUtils.showAbnormalToast(res?.msg || '查询智能体详情失败');
        }
        this.setState({ currentAgent: obj, agentLoading: false });
    };
    //获取智能体列表
    getAgentList = async (applicable_scope) => {
        this.setState({ agentLoading: true });
        const params = {
            page_num: 1,
            page_size: 300,
            applicable_scope: applicable_scope || 2
        };
        const res = await handleAgentList(params);
        let arr = [];
        if (res && res.success) {
            arr = res?.data || [];
        } else {
            ToastUtils.showAbnormalToast(res?.msg || '查询失败');
        }
        this.setState({ agentList: arr, agentLoading: false });
    };
    getStudentName = async () => {
        const res = await handleGetStudentName();
        if (res && res.success) {
            this.setStudentName(res?.data || '');
        }
    };
    getUserInfo = async () => {
        const res = await getUserInfo().finally(() => {
            this.setState({
                loginLoading: false
            });
        });
        if (res && res.success) {
            this.setUserInfo(res?.data || {});
            Storage.set('userInfo', JSON.stringify(res?.data));
            await this.getLoginAndOutConfig();
        }
    };
    getTenantId = async () => {
        let res = await handleGetTenantId();
        if (res && res.success) {
            Storage.set('tenantId', res.data);
        }
    };
    //进入系统调用此方法，如果登录了会继续调用用户信息等接口
    checkLogin = async (isFirst = false) => {
        this.setState({
            loginLoading: true
        });
        const res = await checkToken(); //校验登录
        //首次登录校验登录成功后，需要调用用户信息等接口
        if (res && res.success && res.data) {
            if (isFirst) {
                this.setIsLogin(true);
                this.getStudentName();
                await this.getUserInfo(); //获取用户信息
            }

            return true;
        }
        this.setIsLogin(false);
        Storage.remove('userInfo');
        this.setState({
            loginLoading: false
        });
        return false;
    };
    //判断是否有学员权限
    checkCanUseStudy = async (agentId) => {
        let res = await checkBusiness({ agent_id: agentId });
        return res;
    };
    @observable loginAndOutConfig = {
        logout_config: {
            can_logout: 1,
            logout_redirect_type: 0
        }
    };
    //获取登录和退出配置，判断登录和退出成功后跳到哪里
    getLoginAndOutConfig = async () => {
        let res = await getLoginAndOutGoPath();
        if (res && res.code === '00000') {
            runInAction(() => {
                if (res.data && Object.keys(res.data).length) {
                    this.loginAndOutConfig = res.data;
                } else {
                    this.loginAndOutConfig = {
                        logout_config: {
                            can_logout: 1,
                            logout_redirect_type: 0
                        }
                    };
                }
            });

            return res.data;
        }
        ToastUtils.showAbnormalToast(res.msg || '');
        return false;
    };
    getTenantConfig = async () => {
        let res = await getTenantConfigReq();
        if (res?.success) {
            if (res?.data && res.data?.content?.length) changeName(res.data.content);
        } else {
            ToastUtils.showAbnormalToast(res?.msg);
        }
    };
}
export default new grtAi();
